import { Model } from './Model';

export class UserUpdateLanguage extends Model {
  public apiPath = undefined;
  public className = 'updateUserLanguage';
  public userId: number;
  public language: string;
}
